import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import RegprofAdditionalDocEdit from "../../components/services/additionalDoc/RegprofAdditionalDocEdit";

const RegprofAdditionalDocEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <RegprofAdditionalDocEdit />
    </PageWrapper>
  );
};

export default RegprofAdditionalDocEditPage;
